module.exports = __webpack_public_path__ + "img/main_sp.57b9a47c.svg";